<script lang="ts">
  import {router, Link} from 'yrv';
  import InlineSVG from 'svelte-inline-svg';
  import {writable} from 'svelte/store';

  import {
    LIST,
    LIST_REGEX,
    NEW_PROJECT_REGEX,
    VIEW_PROJECT_REGEX,
    EDIT_PROJECT_REGEX
  } from '../../constants/views';

  import logo from '../../assets/logo.svg';

  import BackButton from '../back-button/BackButton.svelte';
  import Search from '../search/Search.svelte';
  import GoogleAuthentication from '../google-authentication/GoogleAuthentication.svelte';
  import Button from '../button/Button.svelte';
  import ShowcaseLink from '../showcase-link/ShowcaseLink.svelte';

  import {Language, selectedLanguage} from '../../stores/language';
  import LanguageSwitcher from '../language-switcher/LanguageSwitcher.svelte';

  $: showSearch = LIST_REGEX.test($router.path);
  $: showShowCaseLink = LIST_REGEX.test($router.path);

  $: showBackButton =
    NEW_PROJECT_REGEX.test($router.path) ||
    VIEW_PROJECT_REGEX.test($router.path) ||
    EDIT_PROJECT_REGEX.test($router.path);
</script>

<style lang="postcss">
  .header-navigation {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 20;
    display: grid;
    grid-template-columns: auto 1fr repeat(4, auto);
    gap: 0.25rem;
    align-items: center;
    width: 100%;
    padding: 0.5rem;
    background-color: var(--ubilabs-white);
    box-shadow: 0 2px 4px rgba(var(--ubilabs-black-rgb), 0.14),
      0 3px 4px rgba(var(--ubilabs-black-rgb), 0.12);
  }

  @media (min-width: 640px) {
    .header-navigation {
      gap: 0.5rem;
      padding: 0.5rem 1rem;
    }
  }

  @media (min-width: 768px) {
    .header-navigation {
      padding: 1rem 1.5rem;
    }

    .header-navigation :global(.backButton) {
      position: absolute;
      top: 100%;
      left: 0;
      margin: 1.5rem 1rem;
    }
  }

  @media (max-width: 767px) {
    :global(.backButton + a),
    :global(.backButton + a + a) {
      display: none;
    }
  }

  :global(.title) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: inherit;
  }

  :global(.title):hover {
    text-decoration: none;
  }

  :global(.title):focus-visible {
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  :global(.title > svg) {
    flex-shrink: 0;
    display: inline-flex;
    margin: 0 0.5rem;
    font-size: var(--ubilabs-heading-1-font-size);
  }

  :global(.title) h1 {
    margin: 0;
  }

  @media (max-width: 699px) {
    :global(.title) h1,
    :global(.title > svg) {
      font-size: 1.375rem;
    }
  }

  @media (max-width: 639px) {
    :global(.title) {
      grid-column-start: 1;
      grid-column-end: 3;
    }

    :global(.title) h1,
    :global(.title > svg) {
      font-size: 1.125rem;
    }
  }

  @media (min-width: 640px) {
    :global(.title > svg) {
      margin-left: 0.25rem;
    }
  }

  .search {
    flex-grow: 1;
  }

  @media (max-width: 639px) {
    .search {
      grid-row: 2;
      grid-column-start: 1;
      grid-column-end: -1;
      width: 100%;
    }
  }

  @media (min-width: 640px) {
    .search {
      display: flex;
      justify-content: end;
    }
  }
</style>

<nav class="header-navigation">
  {#if showBackButton}
    <BackButton class="backButton" />
  {/if}

  <Link class="title" href={LIST}>
    <InlineSVG src={logo} />
    <h1>Ubilabs Project Gallery</h1>
  </Link>

  {#if showSearch}
    <div class="search">
      <Search />
    </div>
  {/if}
  {#if showShowCaseLink}
    <ShowcaseLink />
  {/if}
  <LanguageSwitcher />
  <GoogleAuthentication />
</nav>
